import { render, staticRenderFns } from "./HomeSocials.vue?vue&type=template&id=81faf298"
import script from "./HomeSocials.vue?vue&type=script&lang=js"
export * from "./HomeSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports